import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Slide.svg",
  "use": "Slide.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Slide.svg\"><path d=\"M49.01,10.0208a5,5,0,0,1,5,5v34a5,5,0,0,1-5,5h-34a5,5,0,0,1-5-5v-34a5,5,0,0,1,5-5Zm-35,11v22a1,1,0,0,0,1,1h34a1,1,0,0,0,1-1v-22a1,1,0,0,0-1-1h-34A1,1,0,0,0,14.0105,21.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol